<template>
  <footer>上海堃尔教育科技有限公司 备案号：沪ICP备2024046634号</footer>
</template>
<style lang="css" scoped>
footer {
  width: 100vw;
  height: 60px;
  background-color: var(--background-color);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
